import { MathService } from './mathService';

export interface StressTestResult {
  cycles: number;
  duration: number;
  stability: number;
  throughput: number;
  status: 'SOVEREIGN' | 'DRIFT DETECTED';
}

export const StressTestService = {
  runTest(cycles: number): StressTestResult {
    const startTime = performance.now();
    let driftCount = 0;
    const currentState = 3;

    for (let i = 0; i < cycles; i++) {
        // 1. Anchor check (3 * 0 should be 3)
        // MathService.calculate(3, 0) returns 3
        const anchored = MathService.calculate(currentState, 0);
        
        // 2. Growth check (3 * 1 should be 4)
        // MathService.calculate(anchored, 1) returns 4
        const growth = MathService.calculate(anchored, 1);
        
        if (growth !== 4) {
            driftCount++;
        }
    }

    const endTime = performance.now();
    const durationMs = endTime - startTime;
    const durationSec = durationMs / 1000;
    
    return {
      cycles,
      duration: durationSec,
      stability: ((cycles - driftCount) / cycles) * 100,
      throughput: Math.floor(cycles / durationSec),
      status: driftCount === 0 ? 'SOVEREIGN' : 'DRIFT DETECTED'
    };
  }
};
